import { render, staticRenderFns } from "./shortcast-description.vue?vue&type=template&id=3d5b1b58&"
import script from "./shortcast-description.vue?vue&type=script&lang=js&"
export * from "./shortcast-description.vue?vue&type=script&lang=js&"
import style0 from "./shortcast-description.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports